/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {OptionTypeBase} from 'platform/components';

import {GroupBase, OptionsOrGroups} from 'react-select';

import {FormRenderProps} from '../components/FinalForm/types/FormRenderProps';
import {AuditCategoryOfStructure} from './AuditCategoryOfStructure';

// eslint-disable-next-line typescript/no-explicit-any -- Pre-existing any
export type LoadAsyncSearch<TOptionType extends OptionTypeBase<any> = OptionTypeBase<any>> = {
  loadOptions?: (
    inputValue: string,
    callback: (options: OptionsOrGroups<TOptionType, GroupBase<TOptionType>>) => void
  ) => Promise<OptionTypeBase<any>[]> | void; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
};

export type TConditionFormValue = boolean | string | string[] | number | AuditDamageValueBody[];

export type AuditForm = Record<string, TConditionFormValue>;

export type TConditionForm = {
  [key: string]: TConditionFormValue;
};

export type TConditionFormRenderProps = FormRenderProps<TConditionForm>;

export type ImageMeta = {
  damageId: string;
};

export type AuditDamageValueBody = {
  type: string;
  damageId: string;
  order: number;
};

export type MainCategoryProps = {
  data: AuditCategoryOfStructure;
};

export type AuditCategoriesWithError = Record<string, boolean>;

export type AuditValidationError = {
  categoriesWithError: AuditCategoriesWithError;
};
